import { observer } from 'mobx-react-lite'
import React from 'react'
import { Link } from 'react-router'

interface RepliesCountProps {
    usersCount: number
    repliesCount: number
    linkTo?: string
}


const RepliesCount: React.FC<RepliesCountProps> = observer(({
    usersCount,
    repliesCount,
    linkTo
}) => {

    const content = (
        <div className="replies-count">
            <div>
                <strong className="text-primary me-2">
                    <span>{usersCount} {usersCount === 1 ? 'person' : 'people'}</span>
                    <span> | </span>
                    <span>{repliesCount} {repliesCount === 1 ? 'reply' : 'replies'}</span>
                </strong>
                <span>
                    Click to view Replies
                </span>
            </div>
        </div>
    )

    if (linkTo) {
        return (
            <Link
                style={{ textDecoration: 'none', color: 'inherit' }}
                to={linkTo}
            >
                {content}
            </Link>
        )
    }

    return content
})

export { RepliesCount }
